import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { HttpError } from 'app/helpers/httpError';
import { HttpRequestHelper } from 'app/helpers/httpRequestHelper';
import { ExposedCreatePensionApplicationOtherFundsReq } from 'app/interfaces/requests/Exposed/exposedCreatePensionApplicationOtherFundsReq';
import { ExposedCreateSpousePensionApplicationOtherFundsReq } from 'app/interfaces/requests/Exposed/exposedCreateSpousePensionApplicationOtherFundsReq';
import { ExposedListFundPartnerFundsRes } from 'app/interfaces/responses/Exposed/exposedListFundPartnerFundsRes';
import { ExposedReadCoredataFileSenderRes } from 'app/interfaces/responses/Exposed/exposedReadCoredataFileSenderRes';
import { ExposedReadFundPartnerInfoRes } from 'app/interfaces/responses/Exposed/exposedReadFundPartnerInfoRes';
import { ExposedSubmitOtherFundsApplicationRes } from 'app/interfaces/responses/Exposed/exposedSubmitOtherFundsApplicationRes';
import { HttpStatus } from 'app/interfaces/support/status/httpStatus';
import { AlertsService } from 'app/services/system/alerts/alerts.service';
import { LoaderService } from 'app/services/system/loader/loader.service';
import { environment } from 'environments/environment';
import { EMPTY, Observable, of } from 'rxjs';
import { catchError, finalize, map, tap } from 'rxjs/operators';

@Injectable({
    providedIn: 'root',
})
export class OtherFundsApplicationsService {
    private httpRequestHelper = new HttpRequestHelper();

    constructor(
        private http: HttpClient,
        private loaderService: LoaderService,
        private alertsService: AlertsService,
        private router: Router,
        public dialog: MatDialog
    ) {}

    public submitPensionOtherFundsApplication(
        applicationType: string,
        data: ExposedCreatePensionApplicationOtherFundsReq | ExposedCreateSpousePensionApplicationOtherFundsReq,
        showError = true
    ): Observable<ExposedSubmitOtherFundsApplicationRes> {
        this.loaderService.changeActiveLoaders(1);
        this.loaderService.changeLoaderMessage('Skrái umsókn');

        return this.http
            .post<
                HttpStatus<ExposedSubmitOtherFundsApplicationRes>
            >(environment.localApi + 'applications/employee/submit/' + applicationType, data, this.httpRequestHelper.getRequestOptionsAuth())
            .pipe(
                map((res) => res.returnItem),
                tap(() => {
                    this.alertsService.changeAlertShowIcon(true);
                    this.alertsService.changeAlertSuccessMessage('Umsókn hefur verið skráð');
                    this.alertsService.changeAlertSuccessShow(true);
                }),
                catchError((error) => {
                    if (showError) {
                        HttpError(this.alertsService, this.router, error, '', '', '', '');
                    } else {
                        console.log(error);
                    }

                    return EMPTY;
                }),
                finalize(() => {
                    this.loaderService.changeActiveLoaders(-1);
                })
            );
    }

    public getFundPartnerFunds(ssn: string, showError = true, showLoader = false): Observable<Array<ExposedListFundPartnerFundsRes>> {
        if (showLoader) {
            this.loaderService.changeActiveLoaders(1);
            this.loaderService.changeLoaderMessage('Sæki sjóði');
        }

        return this.http
            .get<
                HttpStatus<Array<ExposedListFundPartnerFundsRes>>
            >(environment.localApi + 'applications/employee/fund-partners/' + ssn + '/funds', this.httpRequestHelper.getRequestOptionsAuth())
            .pipe(
                map((res) => res.returnItem ?? []),
                catchError((error) => {
                    if (showError) {
                        HttpError(this.alertsService, this.router, error, '', '', '', '');
                    } else {
                        console.log(error);
                    }

                    return of([]);
                }),
                finalize(() => {
                    if (showLoader) {
                        this.loaderService.changeActiveLoaders(-1);
                    }
                })
            );
    }

    public getFundPartnerInfo(ssn: string, showError = true, showLoader = false): Observable<ExposedReadFundPartnerInfoRes> {
        if (showLoader) {
            this.loaderService.changeActiveLoaders(1);
            this.loaderService.changeLoaderMessage('Sæki upplýsingar');
        }

        return this.http
            .get<
                HttpStatus<ExposedReadFundPartnerInfoRes>
            >(environment.localApi + 'applications/employee/fund-partners/' + ssn + '/info', this.httpRequestHelper.getRequestOptionsAuth())
            .pipe(
                map((res) => res.returnItem),
                catchError((error) => {
                    if (showError) {
                        HttpError(this.alertsService, this.router, error, '', '', '', '');
                    } else {
                        console.log(error);
                    }

                    return of(null);
                }),
                finalize(() => {
                    if (showLoader) {
                        this.loaderService.changeActiveLoaders(-1);
                    }
                })
            );
    }

    public getCoredataFileSender(fileId: string, showError = true, showLoader = false): Observable<ExposedReadCoredataFileSenderRes> {
        if (showLoader) {
            this.loaderService.changeActiveLoaders(1);
            this.loaderService.changeLoaderMessage('Sæki skrá');
        }

        return this.http
            .get<
                HttpStatus<ExposedReadCoredataFileSenderRes>
            >(environment.localApi + 'applications/employee/coredata/' + fileId, this.httpRequestHelper.getRequestOptionsAuth())
            .pipe(
                map((res) => res.returnItem),
                catchError((error) => {
                    if (showError) {
                        HttpError(this.alertsService, this.router, error, '', '', '', '');
                    } else {
                        console.log(error);
                    }

                    return of(null);
                }),
                finalize(() => {
                    if (showLoader) {
                        this.loaderService.changeActiveLoaders(-1);
                    }
                })
            );
    }
}
